import { PaywallSubscriptionList } from "@circle-react-shared/Paywalls/PaywallSubscriptionList";
import { PaywallSubscriptionListContextProvider } from "@circle-react-shared/Paywalls/PaywallSubscriptionList/PaywallSubscriptionListContextProvider";
import { EmptyPage } from "../../Filters/EmptyPage";
import { usePaywallSubscriptions } from "./hooks/usePaywallSubscriptions";

export interface SubscriptionList {
  activeFilterTab: string;
  refetchAllSubscriptions: () => void;
  subscriptionsDataByTab: any;
}

export const SubscriptionList = ({
  activeFilterTab,
  subscriptionsDataByTab,
  refetchAllSubscriptions,
}: SubscriptionList) => {
  const subscriptionData = subscriptionsDataByTab[activeFilterTab];
  const { onClickPagination, columnsToRender } = usePaywallSubscriptions({
    subscriptionData,
  });

  if (
    subscriptionData.hasFilters &&
    subscriptionData.totalSubscriptions === 0 &&
    !subscriptionData.isLoadingSubscriptions
  ) {
    return <EmptyPage />;
  }

  return (
    <PaywallSubscriptionListContextProvider
      shouldOpenAdminMemberEdit
      refetchAllSubscriptions={refetchAllSubscriptions}
    >
      <PaywallSubscriptionList
        wrapperClassName="px-6 lg:px-9"
        key={activeFilterTab}
        columnsToRender={columnsToRender}
        subscriptionData={subscriptionData}
        onClickPagination={onClickPagination}
      />
    </PaywallSubscriptionListContextProvider>
  );
};
